/**
 * Fredhopper (Attraqt XO) tracking activity actions.
 *
 * @see https://fredhopper.gitbook.io/product-discovery/tracking-and-sending-events/implementation-guide/sdk
 */
export const FredhopperActivityAction = {
    VIEW: 'view',
    CLICK: 'click',
    ADD_TO_CART: 'add-to-cart',
    REMOVE_FROM_CART: 'remove-from-cart',
    PURCHASE: 'purchase',
};
/** Sandbox tracker key. Used as a fallback until AEM provides a business-unit-specific key. */
export const FREDHOPPER_TEST_TRACKER_KEY = 'e9a476fa-99d7-4b60-85fb-725a19265e7f';
